import { isExternalCompany, isGradingCompany } from 'shared/helpers/matchers/checkCompanyType';

const materialCountRequiredAvailable = companyType =>
  companyType && !isGradingCompany(companyType) && !isExternalCompany(companyType);

export { materialCountRequiredAvailable };
